import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(private http: HttpClient) {}

  getCategories() {
    return this.http.get(`${environment.endpoint}/categories`);
  }

  getSubCategories(id: any) {
    return this.http.get(`${environment.endpoint}/categories/child/${id}`);
  }
  getSocialMediaLinks() {
    return this.http.get(`${environment.endpoint}/home/social-media-links`);
  }
}
